// Shared filename base/ext manipulation for the deterministic naming feature.
// The backend (Document#with_canonical_extension) is the enforcement point —
// this util exists so edit-mode UIs can show only the base name while
// preserving the extension visually and on save.

export interface FilenameParts {
  base: string;
  ext: string;
}

export const splitFilename = (name: string): FilenameParts => {
  if (!name) return { base: '', ext: '' };

  const i = name.lastIndexOf('.');
  // i <= 0 covers "no dot" and "leading dot" (hidden files like .env, .gitignore).
  if (i <= 0) return { base: name, ext: '' };

  return { base: name.slice(0, i), ext: name.slice(i) };
};

export const joinFilename = ({ base, ext }: FilenameParts): string =>
  ext ? `${base}${ext}` : base;
